module.exports = __webpack_public_path__ + "img/bg5.a8e1a311.png";